import request from '@/utils/request'

// 根据父类code获取子类item，非树状
export function getDictSubItem(dictCode) {
  return request({
    url: `api/dict/${dictCode}`,
    method: 'get'
  })
}
// 获取所有字典
export function getDicts() {
  return request({
    url: 'api/dict/all',
    method: 'get'
  })
}
// 获取树状字典
export function getDictTree() {
  return request({
    url: `api/dict/tree`,
    method: 'get'
  })
}

// 获取树状字典子枚举
export function getDictTreeById(id) {
  return request({
    url: `api/dict/tree/${id}`,
    method: 'get'
  })
}

export function add(data) {
  return request({
    url: 'api/dict',
    method: 'post',
    data
  })
}

export function del(ids) {
  return request({
    url: 'api/dict',
    method: 'delete',
    data: ids
  })
}

export function edit(data) {
  return request({
    url: 'api/dict',
    method: 'put',
    data
  })
}

export function download() {
  return request({
    url: 'api/dict/download',
    method: 'get',
    responseType: 'blob'
  })
}

export default { add, edit, del }
